import React from 'react';
import useScrollReveal from '../hooks/useScrollReveal';

export default function Story({ t }) {
  const [titleRef, titleVisible] = useScrollReveal(0.15);
  const [bodyRef, bodyVisible] = useScrollReveal(0.05);

  return (
    <section id="story" className="relative py-24 md:py-32">
      <div className="container mx-auto max-w-3xl px-6">
        <div
          ref={titleRef}
          className="mb-16 text-center"
          style={{
            opacity: titleVisible ? 1 : 0,
            transform: titleVisible ? 'translateY(0)' : 'translateY(20px)',
            transition: 'opacity 0.9s ease-out, transform 0.9s ease-out',
          }}
        >
          <h2
            data-testid="story-title"
            className="text-gradient-gold font-arabic text-3xl font-bold md:text-4xl leading-[1.6] pb-2"
          >
            {t.story.title}
          </h2>
          <div className="mt-4 gold-divider mx-auto w-16" />
        </div>

        <div ref={bodyRef} className="space-y-8">
          {t.story.paragraphs.map((p, i) => (
            <p
              key={i}
              data-testid={`story-paragraph-${i}`}
              className="text-lg leading-loose text-foreground/80 md:text-xl"
              style={{
                opacity: bodyVisible ? 1 : 0,
                transform: bodyVisible ? 'translateY(0)' : 'translateY(20px)',
                transition: `opacity 0.9s ease-out ${i * 0.12}s, transform 0.9s ease-out ${i * 0.12}s`,
              }}
            >
              {p}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
}
